import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
const PutResponseBody = z.object({
    message: z.string(),
});
export const putRaiseCashUrl = (planAssignmentId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/investment/raise-cash/${planAssignmentId}/liquidation`
    : `https://middleware.uat.farther.com/investment/raise-cash/${planAssignmentId}/liquidation`;
export default async function putRaiseCash(config, planAssignmentId, body, idempotencyKey) {
    const { data } = await axios.put(putRaiseCashUrl(planAssignmentId), body, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            version: "20250505",
            ...("advisorId" in config && { Advisor: config.advisorId }),
            "Idempotency-key": idempotencyKey,
            "Content-Type": "application/json",
        },
    });
    const decoded = PutResponseBody.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[putRaiseCash] returned unexpected data.";
        errorLog("putRaiseCash", JSON.stringify(decoded.error.issues));
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=putRaiseCash.js.map